import { ShiftDrawerCollapseSectionEnum } from '@wilson/interfaces';

export class SetShiftDrawerCollapseSettings {
  static readonly type =
    '[ShiftDrawerSettings] Set Shift Drawer Collapse Settings';
  constructor(
    public userId: string,
    public shiftDrawerCollapseSettings: Record<
      ShiftDrawerCollapseSectionEnum,
      boolean
    >,
  ) {}
}

export class SetShiftDrawerCollapseSectionSettings {
  static readonly type =
    '[ShiftDrawerSettings] Set Shift Drawer Collapse Section Settings';
  constructor(
    public userId: string,
    public section: ShiftDrawerCollapseSectionEnum,
    public isCollapsed: boolean,
  ) {}
}
